import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

import config from 'src/config';

import { Spinner } from '../basic';

const mapConfig = config.get('map');

export const Map = ({ addressString, geocode = false, height = 433, width = 272 }) => {
  const [mapState, setMapState] = useState({ key: null, mapUrl: '' });
  const requestKey = geocode && addressString ? addressString : null;
  const mapUrl = mapState.key === requestKey ? mapState.mapUrl : '';
  const loading = !!requestKey && mapState.key !== requestKey;

  const generateMapUrl = useCallback(
    (item) => {
      const mapview = `${item['mapView']['west']},${item['mapView']['south']},${item['mapView']['east']},${item['mapView']['north']}`;
      const latitude = item['position']['lat'];
      const longitude = item['position']['lng'];
      const label = item['address']['label'];

      const marker_param = `overlay=point:${latitude},${longitude};size=large;label=${label};text-color=%23972E2B;text-outline-color=%23FFF;outline-width=2`;

      return `${mapConfig.base_url}bbox:${mapview};padding=64/${width}x${height}/png8?apiKey=${mapConfig.api_key}&${marker_param}&style=lite.day&scaleBar=km`;
    },
    [height, width]
  );

  useEffect(() => {
    if (!requestKey) return undefined;

    let ignore = false;
    let params = new URLSearchParams({
      q: addressString,
      apiKey: mapConfig.api_key
    });
    const uri = `${mapConfig.geocode_url}?${params.toString()}`;

    axios
      .get(uri)
      .then((result) => {
        if (!ignore) {
          const address = result.data.items[0];
          setMapState({
            key: requestKey,
            mapUrl: address ? generateMapUrl(address) : ''
          });
        }
      })
      .catch(() => {
        if (!ignore) {
          setMapState({ key: requestKey, mapUrl: '' });
        }
      });

    return () => {
      ignore = true;
    };
  }, [addressString, generateMapUrl, requestKey]);

  return loading ? (
    <Spinner />
  ) : mapUrl ? (
    <img src={mapUrl} width={'100%'} height={'100%'} />
  ) : null;
};
